import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material'

import { DigitalCertificateRoutingModule } from './digital-certificate-routing.module';
import { MaterialModule } from '../../../../../core/material';
import { DigitalCertificateComponent } from './digital-certificate.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AddDigitalCertificateComponent } from './add-digital-certificate/add-digital-certificate.component';
import { SharedModule } from '../../../../../shared/shared.module';
import { NgMatAutocompleteModule } from 'src/app/shared/components/autocomplete/autocomplete.module';
import { ViewDigitalCertificateComponent } from './view-digital-certificate/view-digital-certificate.component';
import { CertificatePolicyComponent } from './certificate-policy/certificate-policy.component';
import {NgZorroAntdModule} from "ng-zorro-antd";
import {EditDigitalCertificateComponent} from './edit-digital-certificate/edit-digital-certificate.component';
import { DialogSyncDigitalCertificateComponent } from './dialog-sync-digital-certificate/dialog-sync-digital-certificate.component';
import { ShareResourceComponent } from './share-resource/share-resource.component';
import { DefaultSignImageConfigComponent } from './default-sign-image-config/default-sign-image-config.component';
// DefaultSignImageConfigComponent nhúng app-image-sign-config (khai báo + export trong DocumentModule)
import { DocumentModule } from '../document/document.module';


@NgModule({
  declarations: [
    DigitalCertificateComponent,
    AddDigitalCertificateComponent,
    ViewDigitalCertificateComponent,
    CertificatePolicyComponent,
    EditDigitalCertificateComponent,
    DialogSyncDigitalCertificateComponent,
    ShareResourceComponent,
    DefaultSignImageConfigComponent
  ],
    imports: [
        CommonModule,
        DigitalCertificateRoutingModule,
        MatTableModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SharedModule,
        DocumentModule,
        NgMatAutocompleteModule,
        NgZorroAntdModule
    ],
  entryComponents: [
    AddDigitalCertificateComponent,
    ViewDigitalCertificateComponent,
    EditDigitalCertificateComponent,
    DialogSyncDigitalCertificateComponent,
    ShareResourceComponent
  ]
})
export class DigitalCertificateModule { }
